
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Grid, Typography, Link, Divider } from '@mui/material';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900],
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Autopilot One
            </Typography>
            <Typography variant="body2" color="text.secondary">
              A multi-agent, multi-interface AI system that builds secure, production-ready code with fast deployment.
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Resources
            </Typography>
            <Link href="https://www.npmjs.com/package/@loxia-labs/loxia-autopilot-one" target="_blank" rel="noopener noreferrer" color="inherit" display="block" sx={{ mb: 1 }}>
              Documentation
            </Link>
            <Link href="https://www.npmjs.com/package/@loxia-labs/loxia-autopilot-one#api" target="_blank" rel="noopener noreferrer" color="inherit" display="block" sx={{ mb: 1 }}>
              API Reference
            </Link>
            <Link href="https://www.npmjs.com/package/@loxia-labs/loxia-autopilot-one#examples" target="_blank" rel="noopener noreferrer" color="inherit" display="block" sx={{ mb: 1 }}>
              Examples
            </Link>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Company
            </Typography>
            <Link component={RouterLink} to="/about" color="inherit" display="block" sx={{ mb: 1 }}>
              About Us
            </Link>
            <Link component={RouterLink} to="/contact" color="inherit" display="block" sx={{ mb: 1 }}>
              Contact
            </Link>
            <Link component={RouterLink} to="/privacy" color="inherit" display="block" sx={{ mb: 1 }}>
              Privacy Policy
            </Link>
            <Link component={RouterLink} to="/terms" color="inherit" display="block" sx={{ mb: 1 }}>
              Terms of Service
            </Link>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 3 }} />
        
        <Box textAlign="center">
          <Typography variant="body2" color="text.secondary">
            © {currentYear} Autopilot One by Loxia. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
